/**
 * LeagueView - Main view for a specific league accessed via URL slug
 * Example: /MastersOfMusic shows only Masters of Music league data
 * This handles the base route /:leagueSlug (which shows Playlists)
 * Subpaths like /:leagueSlug/leagues and /:leagueSlug/admin are handled by separate routes
 */

import { useParams } from 'react-router-dom';
import { getLeagueNameFromSlug, getDisplayNameFromSlug } from '@/lib/league-slugs';
import Playlists from './Playlists';

const LeagueView = () => {
  const { leagueSlug } = useParams<{ leagueSlug: string }>();

  if (!leagueSlug) {
    return null;
  }

  const leagueName = getLeagueNameFromSlug(leagueSlug);
  const displayName = getDisplayNameFromSlug(leagueSlug) || leagueSlug;

  // Show Playlists for the base league route
  return <Playlists leagueSlug={leagueSlug} leagueName={leagueName || undefined} displayName={displayName || undefined} />;
};

export default LeagueView;
